import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { MapPin, Link2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function InviteJoin() {
  const { token } = useParams();
  const nav = useNavigate();
  const { user, ready } = useAuth();
  const [invite, setInvite] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/invites/${token}`).then(({ data }) => setInvite(data)).catch((e) => setErr(formatApiError(e.response?.data?.detail)));
  }, [token]);

  const accept = async () => {
    if (!user) { nav(`/auth`); return; }
    try {
      const { data } = await api.post(`/invites/${token}/accept`);
      toast.success("You've joined the study");
      nav(`/study/${data.study_id}`);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-md flex-col items-center justify-center px-4 text-center">
      <span className="grid h-14 w-14 place-items-center rounded-full bg-[#F36353]/12 text-[#F36353]"><Link2 size={26} /></span>
      {err ? (
        <><h1 className="mt-4 font-display text-2xl font-bold text-[#0F3D66]">Invite unavailable</h1><p className="mt-2 text-[#6B6763]">{err}</p></>
      ) : invite ? (
        <>
          <h1 className="mt-4 font-display text-2xl font-bold text-[#0F3D66]">You're invited</h1>
          <p className="mt-1 text-lg font-medium text-[#0F3D66]">{invite.title}</p>
          <p className="mt-1 flex items-center justify-center gap-1 text-sm text-[#6B6763]"><MapPin size={14} className="text-[#F36353]" /> {invite.venue.name} · {invite.venue.category}</p>
          <Button onClick={accept} data-testid="accept-invite-btn" className="mt-6 rounded-full bg-[#F36353] px-8 text-white hover:bg-[#D94A3D]">
            {ready && !user ? "Sign in to join" : "Join this study"}
          </Button>
        </>
      ) : (
        <p className="mt-4 text-[#6B6763]">Loading invite…</p>
      )}
    </div>
  );
}
